import {createAndInviteUser, resendInvite, acceptInvite, loadInviteData} from '@/services/invite';
import splitter from 'full-name-splitter';
import {userInviteSent, userInviteAccepted} from '@/lib/track/events'

export default {
  state: {
    inviteInfo: {
      loaded: false,
      valid: true, // we don't check this yet
      user: null,
      accepted: false
    },
  },
  mutations: {
    setInviteState(state, obj) {
      Object.assign(state.inviteInfo, obj);
    }
  },
  actions: {
    async loadInviteData({commit}, {uid, token}) {
      // TODO make endpoint for this
      // Load invite data, so we can validate whether
      // it is valid, show the email, etc.
      // We don't have any of this data, so just mark
      // as loaded without info.

      // just for fun, wait a little bit
      await new Promise(r => setTimeout(r, 150));
      console.log('loaded');

      // Uncomment to test out "real" loaded invite info
      // TODO use flags?
      // commit('setInviteState', {
      //   loaded: true,
      //   valid: true,
      //   user: {first_name: 'Tony', last_name: 'Lownds', email:'tony+2@brandly.com'},
      //   accepted: false
      // });
      // return

      commit('setInviteState', {
        loaded: true,
        valid: true,
        user: null,
        accepted: false
      });
    },
    async inviteMember({getters, dispatch}, email) {
      if (!email) throw new Error('Please fill in an email');
      console.log('invite->', email);
      await createAndInviteUser(getters.teamId, email);
      userInviteSent(email, 'user');
      // Re-fetch team info so that user appears in list
      return dispatch('reloadTeamInfo');
    },
    async inviteAdmin({getters, dispatch}, email) {
      if (!email) throw new Error('Please fill in an email');
      console.log('invite admin->', email);
      await createAndInviteUser(getters.teamId, email, 'admin');
      userInviteSent(email, 'admin');
      // Re-fetch team info so that user appears in list
      return dispatch('reloadTeamInfo');
    },
    async acceptInvite({dispatch}, {uid, token, name, password, first_name, last_name}) {
      if (name) [first_name, last_name] = splitter(name);
      let user = await acceptInvite(uid, token, {password, first_name, last_name});
      await dispatch('setUser', user);
      userInviteAccepted();
    },
    async resendInvite(context, email) {
      let result = await resendInvite(email);
    },
  },
  getters: {
    inviteUser: state => state.inviteInfo.user,
    inviteLoaded: state => state.inviteInfo.loaded
  }
}



// WEBPACK FOOTER //
// ./src/store/invite.js